module.exports = __webpack_public_path__ + "img/title16.fd88337f.png";